export default __webpack_public_path__ + "static/media/ProgressiveLabsPlanDesign_Enrollment.bc256acd.pdf";